export const saveIVKey = (ivKeyObject) => {
  const IVKeys = localStorage.getItem('IVKeys')

  if (IVKeys) {
    localStorage.setItem('IVKeys', JSON.stringify([
      ...JSON.parse(IVKeys),
      ivKeyObject
    ]))

    return
  }

  localStorage.setItem('IVKeys', JSON.stringify([ivKeyObject]))
}

export const getIVKey = (saleOrderId) => {
  const IVKeys = JSON.parse(localStorage.getItem('IVKeys'))

  return IVKeys.find(IVKey => {
    return IVKey.orderId === saleOrderId
  })
}

export const removeIVKey = (iv) => {
  const IVKeys = JSON.parse(localStorage.getItem('IVKeys'))

  const filteredIVKeys = IVKeys.filter(IVKey => {
    return IVKey.ivKey !== iv
  })

  localStorage.setItem('IVKeys', JSON.stringify(filteredIVKeys))
}
